import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Wand2 } from 'lucide-react';

export const ProductCard = ({ product, onClick }) => {
  const firstImage = product.images && product.images[0];
  const imageUrl = firstImage 
    ? `${process.env.REACT_APP_BACKEND_URL}/api/files/${firstImage.path}`
    : null;
  const score = product.completion_score || 0;
  const hasKit = product.marketing_kit_generated;

  return (
    <motion.div
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden cursor-pointer"
      data-testid={`product-card-${product.id}`}
    >
      <div className="aspect-square bg-gray-100 relative">
        {imageUrl ? (
          <img src={imageUrl} alt={product.ai_title || 'Product'} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-300 text-4xl">📦</div>
        )}
        <div className="absolute top-2 right-2 px-2 py-0.5 bg-white/90 backdrop-blur-sm rounded-full text-[10px] font-semibold flex items-center gap-1">
          {product.status === 'published' ? <><CheckCircle2 size={10} className="text-emerald-500" /> Published</> : 'Draft'}
        </div>
        {hasKit && (
          <div className="absolute top-2 left-2 px-2 py-0.5 bg-purple-500/90 backdrop-blur-sm rounded-full text-[10px] font-semibold text-white flex items-center gap-1">
            <Wand2 size={10} /> Kit
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="font-semibold text-slate-800 text-sm mb-1 line-clamp-2">
          {product.ai_title || product.name || 'Untitled Product'}
        </h3>
        {product.price && (
          <p className="text-[#128C7E] font-bold">₹{product.price}</p>
        )}
        {score > 0 && (
          <div className="mt-1.5">
            <div className="flex items-center justify-between text-[10px] text-gray-500 mb-0.5">
              <span>Score</span><span>{score}%</span>
            </div>
            <div className="h-1 bg-gray-100 rounded-full overflow-hidden">
              <div className="h-full bg-[#128C7E] rounded-full transition-all" style={{ width: `${score}%` }} />
            </div>
          </div>
        )}
      </div>
    </motion.div>
  );
};
